const normalizeBase = (value?: string) => (value || '').replace(/\/$/, '')

const normalizePath = (path = '') => (path.startsWith('/') ? path : `/${path}`)

export const appUrl = (path = '') =>
	`${normalizeBase(process.env.BASE_PATH)}${normalizePath(path)}`

export const publicUrl = (path = '') =>
	`${normalizeBase(process.env.PUBLIC_URL || 'https://masterchallenge.me')}${normalizePath(
		path
	)}`
